@switch (columnName) {
  @case ('hasAttachments') {
    @if (element.hasAttachments) {
      <mat-icon [attr.aria-label]="'hasAttachments' | translate">attach_file</mat-icon>
    }
  }
  @case ('competenceCode') {
    <div (click)="routeTo()">{{ element.competenceCode }} {{ element.code }}</div>
  }
  @case ('competenceName') {
    <div (click)="routeTo()">{{ element.name }} {{ element.competenceName }}</div>
  }
  @case ('isInUse') {
    <mat-icon class="material-icons-round">{{ element.isInUse ? 'check' : 'close' }}</mat-icon>
  }
  @case ('isExpiring') {
    <mat-icon class="material-icons-round">{{ element.isExpiring ? 'check' : 'close' }}</mat-icon>
  }
  @case ('expiry') {
    <div (click)="routeTo()">
      @if (element.expiresAt) {
        <div>
          {{ element.expiresAt | date }}
        </div>
      } @else {
        <div>-</div>
      }
    </div>
  }
  @case ('requirementType') {
    <div (click)="routeTo()">
      @if (element.requirementType === 0) {
        <div>
          {{ 'mandatory' | translate | uppercase }}
        </div>
      }
      @if (element.requirementType === 1) {
        <div>
          {{ 'optional' | translate | uppercase }}
        </div>
      }
      @if (element.requirementType === 2) {
        <div>
          {{ 'preferred' | translate | uppercase }}
        </div>
      }
      @if (element.requirementType === 3) {
        <div>
          {{ 'notRequired' | translate | uppercase }}
        </div>
      }
    </div>
  }
  @case ('departments') {
    @for (department of element.requiredForDepartments; track department?.id ?? department) {
      <div>
        {{ department }}
      </div>
    }
    @if (element.requiredForPositionGroups !== null) {
      <div>
        <br />
        @for (depGroup of element.requiredForDepartmentGroups; track depGroup?.id ?? depGroup) {
          <div>
            {{ depGroup }}
          </div>
        }
      </div>
    }
    @for (department of element.departments; track department?.id ?? department) {
      <div>
        {{ department?.name || department }}
      </div>
    }
    @if (element.requiredForPositionGroups !== null) {
      <div>
        <br />
        @for (depGroup of element.departmentGroups; track depGroup?.id ?? depGroup) {
          <div>
            {{ depGroup }}
          </div>
        }
      </div>
    }
  }
  @case ('jobPositions') {
    @for (position of element.requiredForPositions; track position?.id ?? position) {
      <div>
        {{ position }}
      </div>
    }
    @for (posGroup of element.requiredForPositionGroups; track posGroup?.id ?? posGroup) {
      <div>
        {{ posGroup }}
      </div>
    }
  }
  @case ('roles') {
    @for (role of element.requiredForRoles; track role?.id ?? role) {
      <div>
        {{ role }}
      </div>
    }
  }
  @case ('statusCompetenceUser') {
    @if (element.statusType === 0) {
      <mat-icon class="green">circle</mat-icon>
    }
    @if (element.statusType === 1) {
      <mat-icon class="yellow">circle</mat-icon>
    }
    @if (element.statusType === 2) {
      <mat-icon class="red">circle</mat-icon>
    }
    @if (element.statusType === 3) {
      <mat-icon class="orange">circle</mat-icon>
    }
  }
  @case ('positions') {
    @for (position of element.positions; track position?.id ?? position) {
      <div>
        {{ position.name }}
      </div>
    }
  }
  @case ('daysUntilExpired') {
    <div (click)="routeTo()">
      @if (element.daysUntilExpired) {
        <div class="center">
          {{ element.daysUntilExpired }}
        </div>
      } @else {
        <div>-</div>
      }
    </div>
  }
  @case ('registrationComplete') {
    <div (click)="routeTo()">
      @if (element.isRegistrationCompleted === true) {
        <div class="center">
          {{ 'yes' | translate }}
        </div>
      }
      @if (element.isRegistrationCompleted === false) {
        <div class="center">
          {{ 'no' | translate }}
        </div>
      }
    </div>
  }
  @case ('departments') {
    @for (
      positionGroup of element.requiredForPositionGroups;
      track positionGroup?.id ?? positionGroup
    ) {
      <div>
        {{ positionGroup }}
      </div>
    }
  }
  @case ('jobPositionGroup') {
    @for (
      positionGroup of element.requiredForPositionGroups;
      track positionGroup?.id ?? positionGroup
    ) {
      <div>
        {{ positionGroup }}
      </div>
    }
  }
  @case ('jobPositionGroup') {
    @for (positionGroup of element.positionGroups; track positionGroup?.id ?? positionGroup) {
      <div>
        {{ positionGroup }}
      </div>
    }
  }
  @case ('depAndDepGroups') {
    @for (department of element.departments; track department?.id ?? department) {
      <div>
        {{ department }}
      </div>
    }
    @if (element.departmentGroups) {
      <div>
        <br />
        @for (depGroup of element.departmentGroups; track depGroup?.id ?? depGroup) {
          <div>
            {{ depGroup }}
          </div>
        }
      </div>
    }
  }
  @case ('users') {
    @for (user of element.users; track user?.id ?? user) {
      <div>
        {{ user }}
      </div>
    }
  }
  @case ('position') {
    {{ element.position.name }}
  }
  @default {
    {{ element[columnName] }}
  }
}
